import { render, staticRenderFns } from "./RequestReset.vue?vue&type=template&id=b18cb2fa&scoped=true&"
import script from "./RequestReset.vue?vue&type=script&lang=js&"
export * from "./RequestReset.vue?vue&type=script&lang=js&"
import style0 from "./RequestReset.vue?vue&type=style&index=0&id=b18cb2fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b18cb2fa",
  null
  
)

export default component.exports